import React from 'react';
import { Globe } from 'lucide-react';

const ForexFactoryPage = () => {
  return (
    <div className="page-content">
      <h1 className="page-title">Forex Factory Calendar</h1>
      <p className="page-description">Stay updated with economic events and news</p>
      <div className="forex-redirect-card">
        <Globe size={64} className="forex-icon" />
        <h3>Economic Calendar</h3>
        <p>View the latest economic events and their impact on the markets</p>
        <button 
          className="forex-redirect-btn"
          onClick={() => window.open('https://www.forexfactory.com/calendar', '_blank')}
        >
          Open Forex Factory Calendar
        </button>
      </div>
    </div>
  );
};

export default ForexFactoryPage;